'use client';

import { useTranslations } from 'next-intl';

const FooterCopyright = () => {
  const t = useTranslations('footer');
  const year = new Date().getFullYear()?.toString();

  return (
    <section className="flex w-full items-center justify-center py-5">
      <span className="font-semibold vt-text-size-small vt-body-text-darker sm:vt-text-size-small-sm">
        {t('copyright', { year })}
      </span>
    </section>
  );
};

export default FooterCopyright;
